import React from 'react';
const textAreaShort = ({style,value,rows,onChange,name})=>{
    const inPutValue = value !== null? value: "";
    return(
        <textarea style={style} value={inPutValue} rows={rows}
                  onChange={onChange} name={name}>
        </textarea>
    );
};
export default textAreaShort;